/**
 * A constant representing the highest level of user permissions within the system.
 * Used to identify and grant access to restricted features or administrative functionality.
 * Immutable and designed to differentiate super administrator roles from other user roles.
 */
export const SUPER_ADMIN = 'SUPER_ADMIN';
export const ADMIN = 'ADMIN';
export const PRACTITIONER = 'PRACTITIONER';
export const MEMBER = 'MEMBER';

export const AUTHORITY_PRIORITY = [
  SUPER_ADMIN,
  ADMIN,
  PRACTITIONER,
  MEMBER,
] as const;

/**
 * A constant representing the highest level of permission in the system.
 *
 * The `SUPER_ADMIN_PERMISSION` variable is assigned a wildcard value ('*'),
 * which typically indicates unrestricted access across all resources and actions.
 * It is commonly used to grant full administrative privileges to super admin users.
 */
export const SUPER_ADMIN_PERMISSION = '*';

/**
 * Represents a decoded JSON Web Token (JWT).
 *
 * The IDecodedJwt interface provides the structure for a decoded JWT, which consists of
 * three main components: the header, payload, and signature.
 */
export interface IDecodedJwt {
  header: { [key: string]: any },
  payload: { [key: string]: any },
  signature: string
}
